@if (message) {
  <h3>{{ message }}</h3>
}

<section (click)="closeOptions()">
  @if (!optionsOpen && fieldIsConfigurable) {
    <button
      @buttonInOut
      (click)="openConfig($event)"
      class="insert-update-field"
      theme="medium"
      title="Configuration options for {{ activeField?.label }}"
      >
      {{ activeField?.label }} OPTIONS
    </button>
  }

  @if (fields.length > 0) {
    <app-filterable-list
      id="document-sender-fields"
      [title]="'Document sender'"
      [tooltip]="'Fields for the user sending the document'"
      [placeholder]="'Search'"
      [items]="fields"
      (itemInsertedEvent)="onFieldSelected($event)"
      >
    </app-filterable-list>
  }
</section>

<!-- CONFIG OPTIONS -->
<aside [ngClass]="optionsOpen ? 'options-open' : ''">
  <app-field-config #fieldConfigComponent [field]="activeField" [(config)]="fieldConfig" (closeEvent)="closeOptions()"> </app-field-config>
  @if (optionsOpen) {
    <button
      (click)="onUpdateClick()"
      [ngClass]="{ 'needs-saving': modified }"
      [disabled]="!modified"
      theme="medium"
      class="insert-update-field"
      title="Update current field in Document"
      >
      <mat-icon fontIcon="arrow_back_ios_new"></mat-icon>
      UPDATE FIELD
    </button>
  }
</aside>
